import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { Grid, Box, InputLabel, Select, MenuItem } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
const success = require('../images/checked.png');
const fail = require('../images/_delete.png');

const localeTheme = createTheme(
    {

    },
    localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
class EnhancedTableHead extends React.Component {
    render() {
        const {
            order,
            orderBy,
            sortId,
            t
        } = this.props;
        const rows = [
            { id: "store_name", numeric: false, disablePadding: false, label: t("Report.phiLogs.Store"), padding: '10px', field: 'store_name' },
            { id: "operation", numeric: false, disablePadding: false, label: t("Report.purgeTrail.Operation"), padding: '10px', field: 'operation' },
            { id: "purge_success_s3_count", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalPassedDeletion"), padding: '10px', field: 'purge_success_s3_count' },
            { id: "purge_failed_s3_count", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalFailedDeletion"), padding: '10px', field: 'purge_failed_s3_count' },
            { id: "purge_success_db_count", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalPassedupdation"), padding: '10px', field: 'purge_success_db_count' },
            { id: "purge_failed_db_count", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalFailedupdation"), padding: '10px', field: 'purge_failed_db_count' },
            { id: "total_processed_images", numeric: false, disablePadding: false, label: t("Report.purgeTrail.TotalProcessedEntries"), padding: '10px', field: 'total_processed_images' },
            { id: "purge_status", numeric: false, disablePadding: false, label: t("Report.purgeTrail.Status"), padding: '10px', field: 'purge_status' },
            { id: "executaton_date", numeric: false, disablePadding: false, label: t("Report.purgeTrail.ExecutionDate"), padding: '10px', field: 'executaton_date' },
        ];

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                {(
                                    <Tooltip
                                        title={t("Global.Label.Filter.Sort")}
                                        placement={row.numeric ? "bottom-end" : "bottom-start"}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            active={orderBy === row.field && sortId === row.id}
                                            direction={order}
                                        >
                                            {row.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                )}
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)

const styles = theme => ({
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    }
    ,
    padding10px: {
        padding: '8px'
    }
    , formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    }

});

let TransactionFilterObj = {
    searchtext: '',
    fromdate: '',
    todate: '',
    pageNo: 0,
    pageSize: 10,
    group_id: sessionStorage.getItem("groupID")
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class PurgeTrailComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: "desc",
            dob: '',
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            isOpen: false,
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            isDataEmpty: true,
            totalRecords: 0,
            isButtonDisabled: false,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
            isError: false,
            errorMessage: '',
            queryId: "",
            groups: [],
        };
        this.debouceTimeout = null;
    }

    componentDidMount() {
        TransactionFilterObj = {
            searchtext: '',
            fromdate: '',
            todate: '',
            pageNo: 0,
            pageSize: 10,
            group_id: sessionStorage.getItem("groupID")
        }
        this.setState({ loader: true });
        this.fetchSuggestions();
        this.BindGrid();
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }
    handleChangePage = (event, page) => {
        event && event.preventDefault();
        const { data } = this.state;
        TransactionFilterObj.pageNo = page;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangeRowsPerPage = event => {
        const { data } = this.state;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.pageSize = event.target.value;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    //Search Text Box change event
    onSearchChange = (event) => {
        this.debouceTimeout && clearInterval(this.debouceTimeout);
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.searchtext = searchString;
        this.debouceTimeout = setTimeout(() => {
            this.BindGrid();
        }, 1000)
    }

    onFromDateSelect = date => {
        date = date ? moment(date).format() : '';
        this.setState({ fromdate: date });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    };

    onToDateSelect = date => {
        date = date ? moment(date).format() : '';
        this.setState({ todate: date });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ loader: true })
        this.BindGrid();
    };

    handleBlurfrom = (value, date) => {
        this.setState({
            fromdate: null
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    }

    handleBlurtodate = (value, date) => {
        this.setState({
            todate: null
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    }

    BindGrid = () => {
        this.setState({ loader: true, data: null });
        fetch(process.env.REACT_APP_BASEURL + 'purge/patients/pictures/purge-trail', {
            method: 'post',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(TransactionFilterObj)
        }).then(response => {
            try {
                return response.json();
            } catch (error) {
                return null;
            }
        }).then(uData => {
            if (uData && uData.results && uData.results.length > 0) {
                this.setState({ data: uData.results, totalRecords: uData && uData.total });
                setTimeout(() => {
                    this.setState({ loader: uData && uData.total && false, isDataEmpty: false, isButtonDisabled: false });
                }, 5000);
            }
            else {
                this.setState({ data: null, loader: false, isDataEmpty: true, isButtonDisabled: true });
            }
        }).catch((error) => {
            this.setState({ data: null, loader: false, isDataEmpty: true, isButtonDisabled: true, isError: true, errorMessage: error && error.message });
        });
    };

    handleInputChange = (event) => {
        this.setState({ queryId: event.target.value });
        TransactionFilterObj.group_id = event.target.value;
        this.BindGrid();
    };

    fetchSuggestions = async () => {
        try {
            const result = fetch(`${process.env.REACT_APP_BASEURL}groups`, {
                method: "GET",
                withCredentials: true,
                headers: {
                    Authorization:
                        "Bearer " +
                        JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                            .jwtToken,
                    "Content-Type": "application/json",
                },
            }
            );
            result
                .then((result) => {
                    result.json().then((resLocation) => {
                        this.setState({ groups: resLocation && resLocation.data })
                    })
                })
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    render() {
        const { classes, t } = this.props;
        const { data, totalRecords, locale, isError, errorMessage, queryId, groups } = this.state;
        return (
            <div>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }

                <Box component="div">
                    <Grid container spacing={4} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
                        <Grid item xs={3} md={3} style={{ paddingLeft: 0 }}>
                            <FormControl sx={{ width: '100%' }}>
                                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                    <DesktopDatePicker
                                        disableFuture
                                        keyboard
                                        value={this.state.fromdate}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label={t("Report.Transaction.FromDate")}
                                                variant="standard"
                                                allowKeyboardControl={true}
                                                onBlur={this.handleBlurfrom}
                                            />
                                        }
                                        onChange={this.onFromDateSelect}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl sx={{ width: '100%' }}>
                                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                    <DesktopDatePicker
                                        disableFuture
                                        keyboard
                                        value={this.state.todate}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label={t("Report.Transaction.ToDate")}
                                                variant="standard"
                                                allowKeyboardControl={true}
                                                onBlur={this.handleBlurtodate}
                                            />
                                        }
                                        onChange={this.onToDateSelect}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    id="idsearchtxt"
                                    defaultValue=""
                                    value={this.state.searchtxt}
                                    label={t("Report.Transaction.Search")}
                                    onChange={this.onSearchChange}
                                    variant="standard"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3} style={{ paddingLeft: '32px' }}>
                            <FormControl
                                variant='standard'
                                sx={{ m: '0', minWidth: 347 }}
                            >
                                <InputLabel id='preferred-group-label'>
                                    {t('Group.User.GroupControlTitle')}
                                </InputLabel>
                                <Select
                                    labelId='preferred-group-label'
                                    id='preferred-group-select-standard'
                                    value={queryId}
                                    onChange={this.handleInputChange}
                                    variant='standard'
                                    label={t('Group.User.GroupControlTitle')}
                                >
                                    {groups.length > 0 &&
                                        groups.map((type, index) => (
                                            <MenuItem
                                                key={index}
                                                value={type.id}
                                                className={classes.locationType}
                                            >
                                                {type.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>

                <Divider style={{ marginTop: '10px', height: '5px' }} />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            order={TransactionFilterObj.sortOrder}
                            orderBy={TransactionFilterObj.sortColumn}
                            sortId={this.state.sortId}
                        />
                        <TableBody>
                            {!data ?
                                (<TableRow>
                                    {isError ? (
                                        <TableCell colSpan={9} style={{ textAlign: "center", padding: '10px 0px' }}>
                                            <p style={{ color: 'red' }}>Error while fetching purge trail entries: {errorMessage}</p>
                                        </TableCell>
                                    ) : (
                                        <TableCell colSpan={9} style={{ textAlign: "center", padding: '10px 0px' }}>
                                            {this.state.isDataEmpty && t("Report.Transaction.NoDataFound")}
                                        </TableCell>
                                    )}
                                </TableRow>)
                                : data.length && data.length > 0 && data.map(n => {
                                    return (
                                        <TableRow>
                                            <TableCell className={classes.padding10px} >{n.store_name}</TableCell>
                                            <TableCell className={classes.padding10px} >{n.operation}</TableCell>
                                            <TableCell className={classes.padding10px} >{n.purge_success_s3_count}</TableCell>
                                            <TableCell className={classes.padding10px} >{n.purge_failed_s3_count}</TableCell>
                                            <TableCell className={classes.padding10px} >{n.purge_success_db_count}</TableCell>
                                            <TableCell className={classes.padding10px} >{n.purge_failed_db_count}</TableCell>
                                            <TableCell className={classes.padding10px} >{n.total_processed_images}</TableCell>
                                            <TableCell className={classes.padding10px} >
                                                {
                                                    [1, "1"].includes(n.purge_status) ?
                                                        (<img src={success} alt="success" style={{ height: '25px', width: '25px' }} />) :
                                                        (<img src={fail} alt="success" style={{ height: '25px', width: '25px' }} />)
                                                }
                                            </TableCell>
                                            <TableCell className={classes.padding10px} >{n.executaton_date ? this.convertToTimeZone(n && n.executaton_date) : ''}</TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </div>
                <ThemeProvider theme={localeTheme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalRecords || 0}
                        rowsPerPage={TransactionFilterObj.pageSize}
                        page={TransactionFilterObj.pageNo}
                        backIconButtonProps={{
                            "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page"
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

PurgeTrailComponent.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(PurgeTrailComponent));



// WEBPACK FOOTER //
// ./src/components/reports/purge-trail/index.js